import { Disclosure, Transition } from '@headlessui/react';
import { useMediaQuery } from 'react-responsive';
import classNames from 'classnames';

import SocialBar from '../../Molecules/SocialBar';
import Button from '../../Atoms/Button';
import Icon from '../../Atoms/Icon';

import decor1 from '../../../assets/img/footer-decor-right.png';
import decor2 from '../../../assets/img/footer-decor-left.png';
import svg from '../../../constants/svg';

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

const menus = [
  {
    name: 'Specialismen',
    links: [
      {
        name: '(Field) Service Engineer',
        url: '#!!!!'
      },
      {
        name: 'Mechanical Engineers',
        url: '#!'
      },
      {
        name: 'Software & Electrical Engineers',
        url: '#!'
      },
      {
        name: 'Monteurs Technische Dienst',
        url: '#!'
      },
      {
        name: 'Machinebouwers',
        url: '#!'
      },
      {
        name: 'Operators',
        url: '#!'
      },
      {
        name: 'Projectleiders',
        url: '#!'
      },
      {
        name: 'Sales Engineer',
        url: '#!'
      }
    ]
  },
  {
    name: 'Opleidingen',
    links: [
      {
        name: 'Werktuigbouwkunde',
        url: '#!'
      },
      {
        name: 'Elektrotechniek',
        url: '#!'
      },
      {
        name: 'Mecatronica',
        url: '#!'
      },
      {
        name: 'Service Monteur',
        url: '#!'
      },
      {
        name: 'Technische dienst',
        url: '#!'
      }
    ]
  },
  {
    name: 'Synsel Techniek',
    links: [
      {
        name: 'Over ons',
        url: '#!'
      },
      {
        name: 'Onze kandidaten',
        url: '#!'
      },
      {
        name: 'Opdrachtgevers',
        url: '#!'
      },
      {
        name: 'Werken bij',
        url: '#!'
      },
      {
        name: 'Contact opnemen',
        url: '#!'
      }
    ]
  }
];

type LinkProps = {
  name: string;
  url: string;
};

function Panel({ links }: { links: LinkProps[] }) {
  return (
    <Disclosure.Panel
      static
      className="py-2 text-sm lg:text-lg"
    >
      <ul className="flex flex-col items-start justify-start">
        {links.map((link) => (
          <li key={links.indexOf(link)} className="py-1">
            <a
              href={link.url}
              className="text-sl-blue text-opacity-50 transition-colors hover:cursor-pointer hover:text-opacity-100"
            >
              {link.name}
            </a>
          </li>
        ))}
      </ul>
    </Disclosure.Panel>
  );
}

function Footer() {
  const isMobile = useMediaQuery({
    query: `(max-width: 1023px)`
  });

  return (
    <footer className="relative mt-auto py-7 lg:pt-32">
      <div className="mx-auto max-w-7xl">
        <div className="absolute right-0 top-3 hidden w-[10vw] lg:block xl:top-12 2xl:w-[188px]">
          <img src={decor1} alt="" />
        </div>
        <div className="absolute bottom-0 left-0 hidden w-[10vw] lg:block 2xl:w-[164px]">
          <img src={decor2} alt="" />
        </div>
        <div className="relative z-10 flex flex-col items-center gap-14 lg:flex-row-reverse lg:items-start lg:gap-0">
          <div className="flex w-full flex-col items-start justify-between gap-7 px-7 lg:w-3/4 lg:flex-row-reverse">
            {menus.map((menu) => (
              <Disclosure key={menus.indexOf(menu)}>
                {({ open }) => (
                  <div className="flex w-full flex-col items-start justify-start text-left lg:w-64">
                    <Disclosure.Button className="flex w-full items-start justify-start py-1 text-lg font-bold text-sl-blue lg:cursor-default lg:text-2xl">
                      <span>{menu.name}</span>
                      {isMobile && (
                        <Icon
                          icon="chevron-down"
                          className={classNames([
                            open && 'rotate-[90deg]',
                            'my-auto ml-auto text-lg transition-transform duration-200'
                          ])}
                        />
                      )}
                    </Disclosure.Button>
                    {isMobile ? (
                      <Transition
                        show={open}
                        enter="transition duration-300 ease-out"
                        enterFrom="transform -translate-y-6 opacity-0"
                        enterTo="transform translate-y-0 opacity-100"
                        leave="transition duration-100 ease-out"
                        leaveFrom="transform translate-y-0 opacity-100"
                        leaveTo="transform -translate-y-6 opacity-0"
                      >
                        <Panel links={menu.links} />
                      </Transition>
                    ) : (
                      <Panel links={menu.links} />
                    )}
                  </div>
                )}
              </Disclosure>
            ))}
          </div>

          {isMobile && (
            <Button
              color="secondary"
              fullRounded
              size="lg"
              onClick={scrollToTop}
              iconName="arrow-up"
            />
          )}

          <div className="mx-auto flex flex-col items-center justify-start gap-5 px-7 lg:w-1/4 lg:items-start">
            <div className="flex flex-col items-center justify-start gap-5 lg:items-start">
              <a href="/" className="w-44">
                {svg.logoBlue}
              </a>
              <p className="text-center text-sm text-sl-gray">
                Social media
              </p>

              <SocialBar
                className="justify-center md:justify-start"
                socialItems={[
                  {
                    icon: 'facebook',
                    url: 'https://www.facebook.com/synseltechniek'
                  },
                  {
                    icon: 'linkedin',
                    url: 'https://www.linkedin.com/company/synsel-techniek'
                  },
                  {
                    icon: 'twitter',
                    url: 'https://twitter.com/synseltechniek'
                  },
                  {
                    icon: 'instagram',
                    url: 'https://www.instagram.com/synseltechniek'
                  }
                ]}
              />
            </div>
          </div>
        </div>
        {/* <div className="w-full px-7 pt-14 lg:py-0">
          <p className="w-full items-center text-center text-lg font-black text-sl-indigo lg:w-2/3 lg:text-left lg:text-5xl">
            your tech dream, our job
          </p>
        </div> */}

        <div className="mt-12 flex w-full flex-col items-center justify-center gap-16  px-7 text-sm text-sl-gray lg:mt-16 lg:flex-row lg:justify-between">
          <p className="lg:pl-24 2xl:pl-0">
            © <b>{new Date().getFullYear()}</b> Synsel
            Techniek
          </p>

          {!isMobile && (
            <>
              <div className="flex items-center gap-16 lg:ml-auto">
                <a
                  className="transition-colors hover:text-sl-blue"
                  href="#!"
                >
                  Algemene Voorwaarden
                </a>
                <a
                  className="transition-colors hover:text-sl-blue"
                  href="#!"
                >
                  Algemene Voorwaarden
                </a>
              </div>
              <Button
                color="secondary"
                fullRounded
                size="lg"
                onClick={scrollToTop}
                iconName="arrow-up"
              />
            </>
          )}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
